// Feature flags for toggling surfaces without deleting code.
//
// Reviews surfaces (product-page ReviewsSection, standalone /ring/reviews
// page, rating badge on the product carousel, Reviews entry in
// SecondaryNavbar) are hidden when the visitor's region OR language is in
// the sets below. Hidden 2026-04-23 for JP / ja pending Bazaarvoice scope
// confirmation, JP-qualified legal sign-off on disclosure wording, and
// back-translation QA. Empty either set to restore the full reviews
// experience for that axis.
export const REVIEWS_HIDDEN_REGIONS = new Set(['JP']);
export const REVIEWS_HIDDEN_LANGUAGES = new Set(['ja']);

export function isReviewsSectionEnabled(args: {
  region?: string;
  language?: string;
}): boolean {
  const region = args.region?.toUpperCase();
  const language = args.language?.toLowerCase();
  if (region && REVIEWS_HIDDEN_REGIONS.has(region)) return false;
  if (language && REVIEWS_HIDDEN_LANGUAGES.has(language)) return false;
  return true;
}

// Same-Day / Next-Day Delivery on the Ring AIR buy page (badge, ETAs,
// India FAQ pincode copy). Module constant — rebuild to flip.
// false: warehouse "Dispatched by" only; no serviceability fetch, no
// campaigns delivery parse. true: still needs product_campaigns
// delivery.sdd_delivery_available.
export const SDD_NDD_BADGE_ENABLED = true;

// Best Buy pickup on web: the US homepage hero button + store finder, the
// buy-page Delivery step (ship or pick up), and the checkout hold. An
// explicit constant, on in every build: nothing here depends on the deploy
// environment, so a promoted preview and a fresh production build behave
// the same. Set to false and rebuild to pull pickup from every build.
//
// Launch state (31 Oct 2026): the backend flag best_buy:pickup:enabled is
// `public` (while `internal` the API answers Best Buy's SANDBOX stock and the
// site shows the "Test stock" note), and the bbPickup* GTM tags are live in
// GTM-MRTF5WC version 136 (components/ring-pro/BestBuyPickup/config.ts).
// ultrahuman.com hosts call api.ultrahuman.com directly; the
// app/api/ring/best-buy-pickup proxies stay preview-only.
export const BEST_BUY_PICKUP_ENABLED = true;

// Best Buy pickup eligibility from the backend catalogue
// (GET /api/web_v1/ring/best_buy_pickup/catalogue): live since 27 Oct with
// all 32 sizes and their pickup variant ids. Off: no catalogue request, so
// pickup is never available (greyed out on the buy page). There is no
// built-in size list: only the API decides. Rebuild to flip.
export const BEST_BUY_PICKUP_CATALOGUE_ENABLED = true;

// IN homepage 2-hour marketing card. Independent of SDD_NDD_BADGE_ENABLED
// (buy-page ETA badge, campaign parse, India FAQ). Rebuild to flip.
export const TWO_HOUR_HOMEPAGE_HERO_ENABLED = true;

// AE emirate-selector delivery ETA on the Ring AIR buy page (hides the
// warehouse shipping-estimate line entirely on AE and shows the window copy
// in every selection state, including engraving and open/sizing-kit size;
// short SDD/NDD line in the bottom bars and order summary).
// Independent of SDD_NDD_BADGE_ENABLED. Module constant — rebuild to flip.
export const AE_DELIVERY_ETA_ENABLED = true;

// AE homepage 4-hour marketing card, mutually exclusive with the IN 2-hour
// hero above (gated by region). Rebuild to flip.
export const FOUR_HOUR_HOMEPAGE_HERO_AE_ENABLED = true;

// Regions showing the Ring AIR promo copy under the buy-page price. Display
// only. Callers AND this with a live getCampaignForProduct('ring') so the copy
// retires with the discount; empty the set to hide it everywhere.
export const RING_AIR_PROMO_BANNER_REGIONS = new Set(['AE']);

export function isRingAirPromoBannerVisible(region?: string | null): boolean {
  const r = region?.toUpperCase();
  return !!r && RING_AIR_PROMO_BANNER_REGIONS.has(r);
}
